<template>
  <div>
    <p v-if="showTitle" class="has-text-primary is-italic is-size-5 mgb-20px obligatoire">
      <span>
        {{ $t('adresseEmplacement.adresse') }}
      </span>
    </p>
    <div class="columns is-multiline">
      <div class="column is-6">
        <adresse :adresse="adresseCadastraleInformation" :afficherIntitule="false"
          :tableName="EMPLACEMENT" isRequired></adresse>
      </div>
      <gmap-map class="column is-6" :center="center"
                :zoom="adresseCadastraleInformation.longitude !== null
                || adresseCadastraleInformation.latitude !== null
                ? zoomDefault : zoomDefaultSansMarker">
        <gmap-marker :key="m.num" v-for="(m) in markers"
                     :position="m.position" :draggable="true" :icon="m.icon"
                     @dragend="updateCoordinates">
        </gmap-marker>
      </gmap-map>
    </div>
    <div class="columns">
      <code-insee-input
        class="column is-2"
        :label="$t('adresseEmplacement.codeInsee')"
        :adresse="adresseCadastraleInformation"/>
      <b-field :label="$t('adresseEmplacement.agglomeration')" class="column is-4">
        <b-input v-model="adresseCadastraleInformation.agglomeration"></b-input>
      </b-field>
      <b-field :label="$t('adresseEmplacement.lat')" class="column is-3">
        <input-coordonnee v-model="adresseCadastraleInformation.latitude"></input-coordonnee>
      </b-field>
      <b-field :label="$t('adresseEmplacement.long')" class="column is-3">
        <input-coordonnee v-model="adresseCadastraleInformation.longitude"></input-coordonnee>
      </b-field>
    </div>
  </div>
</template>

<script>
import markersGetter from '@/services/general/map/markersGetter';
import inputCoordonnee from '@/components/general/inputCoordonnee';
import centerMapGetter from '@/services/general/map/centerMapGetter';
import { ZOOM_DEFAULT_EMPLACEMENT, CENTER_DEFAULT, ZOOM_DEFAULT_SANS_MARKER } from '@/configuration/general/carteConf';
import adresse from '@/components/general/adresse';
import codeInseeInput from '@/components/general/input/codeInseeInput';
import { EMPLACEMENT } from '@/configuration/ville/villeConf';

export default {
  name: 'adresseCreationEmplacement',
  props: {
    adresseCadastraleInformation: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    inputCoordonnee,
    adresse,
    codeInseeInput,
  },
  data() {
    return {
      EMPLACEMENT: EMPLACEMENT,
      zoomDefault: ZOOM_DEFAULT_EMPLACEMENT,
      zoomDefaultSansMarker: ZOOM_DEFAULT_SANS_MARKER,
    };
  },
  methods: {
    updateCoordinates(location) {
      this.adresseCadastraleInformation.longitude = location.latLng.lng();
      this.adresseCadastraleInformation.latitude = location.latLng.lat();
    },
  },
  computed: {
    markers() {
      return markersGetter(this.adresseCadastraleInformation);
    },
    center() {
      if (this.adresseCadastraleInformation.longitude !== null
        && this.adresseCadastraleInformation.latitude !== null) {
        return centerMapGetter(this.adresseCadastraleInformation, this.markers);
      }
      return centerMapGetter(CENTER_DEFAULT, []);
    },
  },
};
</script>
